import http from './http'

export default class TemplateAPI {
	static getLocalJqueryPath () {
		return window.location.origin + '/plugins/jquery/jquery-1.11.3.min.js'
	}

	static getIframeUrl (projId = '', pageId = '') {
		return window.location.origin + '/page/projhtml' + '?projId=' + projId + '&pageId=' + pageId
	}

	/**
	 * 直播管理
	 */
	// 新增直播
	static postAddLive (params){
		return http.httpPost('/live/setting/add', params)
	}

	// 修改直播
	static postEditorLive (params){
		return http.httpPost('/live/setting/update', params)
	}

	// 获取直播列表
	static getLiveList (params) {
		return http.httpGet('/live/setting/list', params)
	}

	/**
	 * 上传视频到视频云空间
	 * @param params
	 * @returns {Promise | Promise<unknown>}
	 */
	// 获取签名
	static getUploadFileParam (params) {
		return http.httpGet('/yunapi/shop/getUploadFileParamToZs', params)
	}

	// 获取视频封面
	static getUploadFileCover (params) {
		return http.httpGet('/yunapi/shop/getImageToZs', params)
	}

	// 获取视频id
	static postUploadVideoId (params) {
		return http.httpPost('/polyv/playduration/getPolyvVideoOneInfoToZs ', params)
	}

	// 保存编辑视频
	static saveEditorVideo (params) {
		return http.httpPost('/yunapi/shop/editVideoToZs', params)
	}

	// 获取视频列表
	static getVideoList (params) {
		return http.httpGet('/polyv/playduration/list', params)
	}

	/**
	 * 上传视频结束
	 */

	// 保存节点
	static saveNodes (params, data) {
		return http.httpPost(
			'/lavrock/edit/saveNodes',
			{
				nodes: data
			},
			params
		)
	}

	// 获取撤销或前进按钮状态
	static getAviliable (params) {
		return http.httpGet('/lavrock/pagehis/aviliable', params)
	}
	/*
	 * 获取项目信息*/
	static getProjectInfo (params) {
		return http.httpGet('/lavrock/project/config', params)
	}
	/*
	 * 大保存
	 * */
	static saveHtmlInDatabase (data, params) {
		return http.httpPost('/edit/html', { ...data }, params)
	}

	/*
	 * 删除页面
	 * */
	static deletePage (params) {
		return http.httpDelete('/page/projpage', params)
	}
	/*
	 * 复制页面
	 * */
	static copyPage (data, params) {
		return http.httpPut(
			'/page/pagecopy',
			{
				...data
			},
			params
		)
	}

	/*
	 * 获取已经删除的页面
	 * */
	static getDeletePage (params) {
		return http.httpGet('/page/projpage', params)
	}
	/*
	 * 还原页面
	 * */
	static recoverPage (data, params) {
		return http.httpPut('/page/recpage', data, params)
	}

	/*
	 * 回收站删除页面
	 * */
	static completelyDeletePage (params) {
		return http.httpDelete('/page/completelyDeletePage', params)
	}

	/*
	 * 获取页面导航的seo*/
	static getPageSeo (params) {
		return http.httpGet('/edit/seo', params)
	}
	/*
	 * 设置页面seo*/
	static savePageSeo (data, params) {
		return http.httpPut('/edit/seo', data, params)
	}

	/*获取图片上传的token*/
	static getUpToken (params = {}) {
		return http.httpGet('/common/upToken', params)
	}

	/*上传*/
	static uploadFile (data) {
		return http.httpPost('http://up-z2.qiniup.com', data, null)
	}
	/*
	 * 获取导航链接*/
	static getNavInfo (params) {
		return http.httpGet('/lavrock/edit/projnav', params)
	}
	/*
	 * 获取历史状态
	 * */
	static getPrevHistory (params) {
		return http.httpGet('/pagehis/previous', params)
	}
	static getNextHistory (params) {
		return http.httpGet('/pagehis/next', params)
	}

	/*添加页面*/
	static addTplPage (params) {
		return http.httpPut('/page/userpagetype', {}, params)
	}

	static uploadImgByUrl (params) {
		return http.httpGet('/edit/uploadImgByUrl', params)
	}

	//添加外链导航
	//http://localhost:8090/lavrock/edit/navlink
	/**
	 {
	 "projId":"bef5c008964341b9a",
	 "pageName":"页面名称",
	 "urlLink":"连接"
	 }
	 */
	static addNavLink (params) {
		return http.httpPost('/lavrock/edit/navlink', params)
	}

	static checkEdit (params) {
		return http.httpGet('/lavrock/auth/common/checkEdit', params)
	}

	/**
	 * 获取队列栈信息
	 * @returns {*}
	 */
	static getProjectCheckState (params) {
		return http.httpGet('/lavrock/common/project/info', params)
	}

	/**
	 * 获取发布进度
	 * @param params
	 * @returns {*}
	 */
	static getProgress (params) {
		return http.httpGet('/lavrock/common/xw/progress', params)
	}
	/**
	 * 查看项目是发布还是检查
	 * @param params.taskId  发布的taskid
	 * @returns {*}
	 */
	static getProjectQueue (params) {
		return http.httpGet('/lavrock/common/pool', params)
	}

	/**
	 * 会员中心-我的课程
	 * @param params.offset 	页码
	 * @param params.count 		页数
	 * @param params.videoTypeName 	//获取全部课程填写全部课程
	 * @param params.status 	状态 0代表未学习完，1代表已学习完
	 * @returns {*}
	 */
	static getNoLookNum (params) {
		return http.httpGet('/lavrock/member/manager/memberVideos', params)
	}

	/**
	 * 发送检测
	 * @param params.projId
	 * @param params.taskId
	 * @param params.publishType = 2
	 * @returns {*}
	 */
	static sendCheck (params) {
		return http.httpGet('/lavrock/publish/project', params)
	}

	/**
	 * 检查回调结果查询
	 * @param params.projId
	 * @param params.pageNo
	 * @param params.pageSize
	 * @returns {*}
	 */
	static getResult (params) {
		return http.httpGet('/lavrock/publish/cresult', params)
	}

	/**
	 * 获取可检测次数
	 * @param params.projId
	 * @returns {*}
	 */
	static getCheckCount (params) {
		return http.httpGet('/lavrock/publish/check/count', params)
	}

	/**
	 * 会员中心-检测是否能发布
	 * @param params
	 * @returns {*}
	 */
	static getPublished (params) {
		return http.httpGet('/lavrock/member/manager/published', params)
	}

	static getPageByHref (params) {
		return http.httpGet('/lavrock/edit/pagename', params)
	}
	// 自定义url判重
	static checkHtmlUrl (params) {
		return http.httpGet('/edit/htmlUrl', params)
	}

	//	设置定时发布时间
	static setReleaseTime (params) {
		return http.httpGet('/edit/releaseTime', params)
	}
	//	查询当前页是是否发布
	static selectPageRelease (params) {
		return http.httpGet('/edit/selectPageRelease', params)
	}

	//	获取全部定时发布的时间日期
	static getAllReleaseTime (params) {
		return http.httpGet('/edit/getAllReleaseTime', params)
	}

	//	查询设置了定时的页面数据
	static getPublishedPage (params) {
		return http.httpGet('edit/getPublishedPage', params)
	}

	//	保存留言表单字段
	static saveMessageSite (params, data) {
		return http.httpPost('/leaveMessageSite/saveLeaveMessageSite', params, data)
	}
	//	项目的所有表单
	static findPositionTypeName (params) {
		return http.httpGet('/leaveMessageSite/findPositionTypeName', params)
	}
	//	项目的所有表单
	static tableNameList (params) {
		return http.httpGet('/leaveMessageSite/list', params)
	}
	//	 表单信息
	static leaveMessageList (params) {
		return http.httpGet('/leaveMessageSite/leaveMessageList', params)
	}
	//	 获取留言表单模板
	static findTemplate (params) {
		return http.httpGet('/leaveMessageSite/findTemplate', params)
	}
	//	 获取第一次上线的留言表单数据
	static findFirstFormData (params) {
		return http.httpGet('/leaveMessageSite/findFirstFormData', params)
	}
	//	 获取客服探头模板
	static findToolTemplate () {
		return http.httpGet('/leaveMessageSite/findToolTemplate')
	}
	//	 变更探头js
	static updateToolTemplateHtml (params) {
		return http.httpGet('/leaveMessageSite/updateToolTemplateHtml', params)
	}
	//	 通过页面id和页面类型获取构件相关数据
	static getStructurePage (params) {
		return http.httpGet('/structurePageRelation/page/list', params)
	}
	//	 通过项目id和页面类型获取构件相关数据
	static getStructureProj (params) {
		return http.httpGet('/structurePageRelation/proj/list', params)
	}
	//	保存或更新页面构件关联
	static saveOrUpdate (params, data) {
		return http.httpPost('/structurePageRelation/saveOrUpdate', params, data)
	}
	/**
	 * 返回项目所有的产品文章 data.json
	 * @param {*} params
	 */
	static getProjectProdDesc (data) {
		return http.httpGet('/project/getProjectProdDesc', data)
	}
	/**
	 * 项目ID查询项目权限的接口
	 * @param {*} params
	 */
	static selectSuitDetailByProjectId (data) {
		return http.httpGet('/productSuit/selectSuitDetailByProjectId', data)
	}
	/**
	 * 查询 文章页 详情页 单页数量
	 * @param {*} params
	 */
	static getPageCount (params) {
		return http.httpGet('/page/getPageCount', params)
	}
	/**
	 * 保存子域名
	 * @param {*} params
	 */
	static saveOrUpdateSubDomain (params) {
		return http.httpPost('/projectSubDomain/saveOrUpdateSubDomain', params)
	}
}

